package fr.frux.shared.data.local

/**
 * Persistance locale des favoris (#61, epic #8), derrière [fr.frux.shared.domain.favorites.FavoritesStore] :
 * les ids survivent au redémarrage et se relisent avant le réseau. Cache de la vérité serveur,
 * jamais une file de synchronisation — une bascule non confirmée par le réseau n'y entre pas.
 */
interface FavoriteLocalDataSource {
    suspend fun favoriteIds(): Set<Long>

    suspend fun setFavorite(
        treeId: Long,
        isFavorite: Boolean,
    )

    /** Remplace tout le contenu par [ids] en une transaction : jamais d'état partiel en base. */
    suspend fun replaceAll(ids: Set<Long>)

    suspend fun clear()
}

/**
 * Implémentation sans stockage pour les cibles sans driver SQLite (web, cf. #59) : lectures
 * vides, écritures ignorées — les favoris redeviennent réseau seul, comme avant #61.
 */
object NoOpFavoriteLocalDataSource : FavoriteLocalDataSource {
    override suspend fun favoriteIds(): Set<Long> = emptySet()

    override suspend fun setFavorite(
        treeId: Long,
        isFavorite: Boolean,
    ) = Unit

    override suspend fun replaceAll(ids: Set<Long>) = Unit

    override suspend fun clear() = Unit
}
